"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ramda_1 = require("ramda");
var constants_1 = require("../../modules/playback/constants");
var actions_1 = require("../../modules/playback/actions");
var pomeranian_durations_1 = require("pomeranian-durations");
var selectors_1 = require("../../modules/playback/selectors");
exports.default = (function (store) { return function (next) { return function (action) {
    var _a;
    if (action.type === constants_1.REFRESH_PLAYBACK_HEARTBEAT + "_SUCCESS") {
        var _b = action.meta, mediaAssetId_1 = _b.mediaAssetId, isLive_1 = _b.isLive, deviceId_1 = _b.deviceId;
        var source = action.payload.vodPlaybackHeartbeat || action.payload.linearPlaybackHeartbeat;
        var isError = !ramda_1.isNil((_a = selectors_1.getPlaybackMeta(store.getState())(mediaAssetId_1)) === null || _a === void 0 ? void 0 : _a.playbackSource) &&
            selectors_1.isConcurrentPlaybackError(store.getState())(mediaAssetId_1);
        var nextHeartbeat = pomeranian_durations_1.asMilliseconds(source === null || source === void 0 ? void 0 : source.timeToNextHeartbeat);
        var heartBeatInterval = isError
            ? null
            : setTimeout(function () { return store.dispatch(actions_1.refreshPlaybackHeartbeat(mediaAssetId_1, isLive_1, deviceId_1)); }, nextHeartbeat);
        store.dispatch(actions_1.setPlaybackHeartbeat(mediaAssetId_1, heartBeatInterval));
    }
    return next(action);
}; }; });
//# sourceMappingURL=index.js.map